import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import Source from 'ol/source/XYZ.js';
import Layer from 'ol/layer/WebGLTile.js';
import { Circle, Fill, Stroke, Style, Icon, Text } from 'ol/style.js';
import Group from 'ol/layer/Group';
import VectorImage from 'ol/layer/VectorImage';
import Point from 'ol/geom/Point.js';


export function stylePlacesFunctionEn(feature) {

  return [
    new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0)',
      }),
      stroke: new Stroke({
        color: 'rgba(255,255,255,0)',
        width: 0,
      }),
      text: new Text({
        font: '14px Albert Sans, sans-serif',
        textBaseline: 'ideographic',
        textAlign: 'left',
        offsetX: 5,
        offsetY: -5,

        text: feature.get("place_name_caption_form"),
        fill: new Fill({
          color: '#000'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        })
      }),
    })
  ];
}

export function stylePlacesFunctionPl(feature) {

  return [
    new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0)',
      }),
      stroke: new Stroke({
        color: 'rgba(255,255,255,0)',
        width: 0,
      }),
      text: new Text({
        font: '14px Albert Sans, sans-serif',
        textBaseline: 'ideographic',
        textAlign: 'left',
        offsetX: 5,
        offsetY: -5,

        text: feature.get("place_name_caption_form_pl"),
        fill: new Fill({
          color: '#000'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        })
      }),
    })
  ];
}
export const selectDataStyleFunctionEN = function (feature) {

  var zindex = 3000 - sortedData.findIndex(p => p.IDI == feature.get("IDI_No"))

  var style = new Style({
    image: new Circle({
      radius: 5,
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({ color: '#7e897a8b', width: 8 }),
    }),
    text: new Text({
      font: '16px Albert Sans, sans-serif',
      textBaseline: 'ideographic',
      textAlign: 'left',
      offsetX: 5,
      offsetY: -5,

      text: [feature.get("place_name_caption_form"), 'bold 16px sans-serif'],
      fill: new Fill({
        color: '#7e897a'
      }),
      stroke: new Stroke({
        color: '#ffffffff',
        width: 1
      })
    }),
    zIndex: zindex,
  });
  return style;
}
export const selectDataStyleFunctionPL = function (feature) {

  var zindex = 3000 - sortedData.findIndex(p => p.IDI == feature.get("IDI_No"))

  var style = new Style({
    image: new Circle({
      radius: 5,
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({ color: '#7e897a8b', width: 8 }),
    }),
    text: new Text({
      font: '16px Albert Sans, sans-serif',
      textBaseline: 'ideographic',
      textAlign: 'left',
      offsetX: 5,
      offsetY: -5,

      text: [feature.get("place_name_caption_form_pl"), 'bold 16px sans-serif'],
      fill: new Fill({
        color: '#7e897a'
      }),
      stroke: new Stroke({
        color: '#ffffffff',
        width: 1
      })
    }),
    zIndex: zindex,
  });
  return style;
}

const dataStyleFunction = function (feature) {

  var zindex = 3000 - sortedData.findIndex(p => p.IDI == feature.get("IDI_No"))

  var style = new Style({
    image: new Circle({
      radius: 5,
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({ color: '#7e897a', width: 1.25 }),
    }),
    zIndex: zindex,
  });
  return style;
}


const styleTravelsFunction = function (feature) {
  const geometry = feature.getGeometry();
  if (feature.get("Travels_stage") == 1) {
    var color = '#578042';
    var arrow = 'arrow_green.png'
  }
  if (feature.get("Travels_stage") == 2) {
    var color = '#4d81c5';
    var arrow = 'arrow_blue.png'
  }
  if (feature.get("Travels_stage") == 3) {
    var color = '#846095';
    var arrow = 'arrow_purple.png'
  }


  const styles = [
    // linestring
    new Style({
      stroke: new Stroke({
        color: color,
        width: 1.5,
      }),
    }),
  ];

  geometry.forEachSegment(function (start, end) {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const rotation = Math.atan2(dy, dx);
    const mx = (end[0] - start[0]) / 3 + start[0];
    const my = (end[1] - start[1]) / 3 + start[1];

    const middle = [mx, my]
    // arrows
    styles.push(
      new Style({
        geometry: new Point(middle),
        image: new Icon({
          src: './assets/images/' + arrow,
          anchor: [0.75, 0.5],
          rotateWithView: true,
          rotation: -rotation,
          scale: 0.7,
        }),
      }),
    );
  });

  return styles;
}

const styleChronologicalFunction = function (feature) {
  const geometry = feature.getGeometry();
  var color = '#00000091';
  var arrow = 'arrow_black.png'

  const styles = [
    // linestring
    new Style({
      stroke: new Stroke({
        color: color,
        width: 1,
      }),
    }),
  ];

  geometry.forEachSegment(function (start, end) {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const rotation = Math.atan2(dy, dx);
    const mx = (end[0] - start[0]) / 3 + start[0];
    const my = (end[1] - start[1]) / 3 + start[1];

    const middle = [mx, my]
    // arrows
    styles.push(
      new Style({
        geometry: new Point(middle),
        image: new Icon({
          src: './assets/images/' + arrow,
          anchor: [0.75, 0.5],
          rotateWithView: true,
          rotation: -rotation,
          scale: 0.7,
          opacity: 0.5,
        }),
      }),
    );
  });

  return styles;
}

const esriTerrainBase = new Layer({
  source: new Source({
    attributions: 'Tiles &copy; Esri &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
  }),
  title: "ESRI Terrain",
  layerName: 'esriTerrain',
  baseLayer: true,
  maxZoom: 9.2,
  preview: "./assets/images/esri_terrain.png",
  displayInLayerSwitcher: true,
  visible: false,
});

const esriWorldShadedRelief = new Layer({
  source: new Source({
    attributions: 'Tiles &copy; Esri &mdash; Source: Esri',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
  }),
  title: "ESRI World",
  layerName: 'esriWorld',
  baseLayer: true,
  maxZoom: 9.8,
  visible: true,
  displayInLayerSwitcher: true
});


const osm = new TileLayer({
  title: "OSM",
  baseLayer: true,
  source: new OSM(),
  visible: false,
  displayInLayerSwitcher: true,
});

export var itineraryEntriesData = new VectorSource({
  url: './assets/data/itinerary-entries.geojson',
  projection: 'EPSG:4326',
  format: new GeoJSON()
});

export let sortedData = [];

export function generateSortedData() {
  sortedData = [];
  itineraryEntriesData.getFeatures().forEach(function (f) {

    if (f.getStyleFunction() == undefined && !(sortedData.some(({ IDI }) => IDI === f.values_.IDI_No))) {
      sortedData.push({
        IDI: f.values_.IDI_No,
        StartDate: f.values_.START_date,
        TimeSpanSequence: f.values_.time_span_SEQUENCE,
      });
    }
  });
  sortedData.sort(function (a, b) {

    var o1 = parseInt(a.TimeSpanSequence);
    var o2 = parseInt(b.TimeSpanSequence);

    var p1 = Date.parse(a.StartDate);
    var p2 = Date.parse(b.StartDate);


    if (p1 < p2) return -1;
    if (p1 > p2) return 1;
    if (o1 < o2) return -1;
    if (o1 > o2) return 1;
    return 0;
  })
  return sortedData;
}


export var itineraryPlacesData = new VectorSource({
  url: './assets/data/itinerary-places.geojson',
  projection: 'EPSG:4326',
  format: new GeoJSON()
});


export const travelsData = new VectorSource({
  format: new GeoJSON(),
  url: './assets/data/travels.geojson',
  projection: 'EPSG:4326',
});

export const chronologicalData = new VectorSource({
  format: new GeoJSON(),
  url: './assets/data/chronological.geojson',
  projection: 'EPSG:4326',
});

export const chronological = new VectorImage({
  source: chronologicalData,
  title: "chronological",
  layerName: 'chronological',
  visible: false,
  style: styleChronologicalFunction
});

export const travels = new VectorImage({
  source: travelsData,
  title: "Podróże",
  layerName: 'travels',
  style: styleTravelsFunction,
  displayInLayerSwitcher: false,
});

$('#toggleTravels').on("change", function () {
  if ($(this).prop('checked'))
    travels.setVisible(true)
  else
    travels.setVisible(false)
})

export const itineraryEntries = new VectorLayer({
  source: itineraryEntriesData,
  title: "itinerary Entries",
  layerName: 'itineraryEntries',
  style: dataStyleFunction,
  displayInLayerSwitcher: false
});


export const itineraryLabelPlaces = new VectorLayer({
  source: itineraryEntriesData,
  title: "itinerary Entries",
  layerName: 'itineraryLabelPlaces',
  style: stylePlacesFunctionEn,
  declutter: true,
  displayInLayerSwitcher: false
});

const itineraryPlaces = new VectorLayer({
  source: itineraryPlacesData,
  title: "itinerary Entries",
  layerName: 'itineraryPlaces',
  style: [],
  displayInLayerSwitcher: false
});

itineraryEntries.on('change:visible', function () {
  var visibility = itineraryEntries.getVisible();
  itineraryLabelPlaces.setVisible(visibility)
});

export const baseLayers = new Group({
  title: 'Base Maps',
  openInLayerSwitcher: false,
  layers: [
    esriWorldShadedRelief,
    esriTerrainBase,
    osm,
  ]
});

export const stages = new Group({
  layers: [
    travels,
    chronological,
    itineraryPlaces,
    itineraryEntries,
    itineraryLabelPlaces,
  ]
});
export const layers = [
  baseLayers,
  stages,
]